<template>
	<span class="message-time" v-text="time" />
</template>

<script>
import { getLocalDate, isDateISO } from '@/helpers/utils'
import moment from 'moment'

// TODO: add an interval timer of some kind to update this time string
// whenever we cross over the midnight boundary into a new day so that
// the "Yesterday" part is always accurate, even if the user is up late
// or leaves a particular group open for a long time

export default {
	name: 'MessageTime',
	props: {
		date: String,
		todayFormat: {
			type: String,
			default: 'LT',
		},
		yesterdayFormat: String,
		defaultFormat: {
			type: String,
			default: 'l, LT',
		},
	},
	data() {
		return {
			today: moment(),
			yesterday: moment().subtract(1, 'day'),
		}
	},
	computed: {
		time() {
			if (!this.date) return ''
			const date = moment(getLocalDate(this.date))
			if (date.isSame(this.today, 'day')) {
				return date.format(this.todayFormat)
			}
			if (date.isSame(this.yesterday, 'day')) {
				return date.format(
					this.yesterdayFormat || `[${this.$t('common_yesterday')},] LT`
				)
			}
			return date.format(this.defaultFormat)
		},
	},
}
</script>

<style scoped>
.message-time {
	font-family: Avenir-Book;
	font-size: 12px;
	color: var(--neutral-400);
	display: inline-block;
	margin-left: 8px;
	flex-shrink: 0;
}
</style>
